import { z } from "zod";

export const serverResponse = z.object({
  digital: z.array(
    z.object({
      id: z.string(),
      state: z.string(),
      offer: z.object({
        description: z.string(),
        validUntilDate: z.string(),
      }),
    }),
  ),
});

export type IPromoCode = z.infer<typeof serverResponse>;
